// extracted by mini-css-extract-plugin
module.exports = {"Component":"DataTableLocationDetailPriceType_Component__2Ojg5"};